<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">
  <div class="cursor-pointer pl-2 bg-{{$.row?.color}}-400 h-full absolute left-0 top-0"></div>
   <a *ngIf="$.row[$.adata.keyName]"  class="cursor-pointer  relative pl-3 text-{{$.row?.color}}-400" tooltipStyleClass="text-xs" (click)="onGoToRoute($.adata?.uri, $.row, $.adata?.canRedirect ? $.adata?.canRedirect == 'true' ? true : false : true )" [pTooltip]="$.row[$.adata.keyName]">{{$.row[$.adata.keyName].toString().length >24?($.row[$.adata.keyName] | slice:0:24 )+'...':$.row[$.adata.keyName] }}
  </a>
</ng-container>